module.exports = __webpack_public_path__ + "img/Settings.4e308681.png";